export default function isStringValidNum(value: string): boolean {
  // we only process strings!
  if (typeof value != 'string') return false;
  // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
  return !isNaN(parseFloat(value)) && !isNaN(parseInt(value));
}
